import { render, staticRenderFns } from "./wxloginRedirect.vue?vue&type=template&id=53bd71a4&scoped=true&"
import script from "./wxloginRedirect.vue?vue&type=script&lang=js&"
export * from "./wxloginRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bd71a4",
  null
  
)

export default component.exports